export default __webpack_public_path__ + "static/media/Objects1.05d10e35.png";